import { createSelector } from 'reselect';

const portalsSelector = state => state.portals;
const activePortalIdSelector = state => state.activePortal;
const activePortalSelector = createSelector(portalsSelector, activePortalIdSelector, (portals, activePortal) => portals[activePortal]);

export default activePortalSelector;
